
  import { defineComponent } from 'vue';

  import RedesignedSwitchComponent from '@/common/components/redesigned/RedesignedSwitchComponent.vue';

  export default defineComponent({
    name: 'SwitchTab',
    components: {
      RedesignedSwitchComponent,
    },
    props: {
      textTrue: {
        type: String,
        required: true,
      },
      textFalse: {
        type: String,
        required: true,
      },
      mode: {
        type: String,
        default: 'default',
        validator: (value: string) => ['default', 'line'].includes(value),
      },
      defaultSelectSecondTab: {
        type: Boolean,
        default: false,
      },
    },
    data(): { isChecked: boolean } {
      return {
        isChecked: !this.defaultSelectSecondTab,
      };
    },
    methods: {
      switchHandler(isChecked: boolean) {
        this.isChecked = isChecked;
      },
    },
  });
